import { Box, Card, Flex, Heading, Text } from "@radix-ui/themes";
import { siteRoutes } from "@/routes/siteRoutesList";
import i18next from "i18next";
import { FC } from "react";
import { Link } from "react-router-dom";

export const AuthCard: FC<{
  children: any;
  title: string;
  type: "login" | "signup" | "verify-email" | "" | "forgot-password";
}> = ({ children, title, type }) => {
  return (
    <Box px="5">
      <Card size="4" variant="surface">
        <Box>
          <Heading as="h1" mb="0">
            {title}
          </Heading>
          <Flex mb="5">
            <Text size="2">
              {type === "login" && (
                <>
                  <Text color="gray">
                    {i18next.t("auth.authcard.unregistered")}{" "}
                  </Text>
                  <Link to={siteRoutes["signUp"]}>
                    {i18next.t("auth.authcard.create")}.
                  </Link>
                </>
              )}
              {type === "signup" && (
                <>
                  <Text color="gray">
                    {i18next.t("auth.authcard.registered")}{" "}
                  </Text>
                  <Link to={siteRoutes["login"]}>
                    {" "}
                    {i18next.t("auth.authcard.login")}
                  </Link>
                </>
              )}
              {type === "verify-email" && (
                <>
                  {i18next.t("auth.authcard.verify_email")}{" "}
                  {localStorage.getItem("authEmailLocal")}
                </>
              )}
              {type == "forgot-password" &&
                i18next.t("auth.authcard.forgot_password")}
            </Text>
          </Flex>
        </Box>
        <Box>{children}</Box>
      </Card>
    </Box>
  );
};
